import { AnyAction } from "redux";

import { CaseAdmin, CaseDocumentAdmin } from "pwapi";

import { ADMIN_UPDATE_INTEGRATIONS_SUCCESS } from "shared/actions/adminConstants";

import {
  CREATE_LIS_SPECIMEN_SUCCESS,
  DELETE_LIS_SPECIMEN_SUCCESS,
  FETCH_LIS_CASE_FAILURE,
  FETCH_LIS_CASE_REQUEST,
  FETCH_LIS_CASE_SUCCESS,
  UPDATE_LIS_CASE_SUCCESS,
  UPLOAD_LIS_DOCUMENT_SUCCESS,
} from "../constants";

export interface CaseState
  extends Omit<
    CaseAdmin,
    | "specimens"
    | "slides"
    | "accession"
    | "patient"
    | "working_reasons"
    | "event_log"
    | "status_log"
    | "finalizing_signature"
  > {
  accession?: string;
  patient?: number;
  specimens?: number[];
  slides?: number[];
  working_reasons?: any;
  isLoading: boolean;
}

const initialState: CaseState = {
  slides: [],
  specimens: [],
  qa_reviews: [],
  screen_requests: [],
  isLoading: true,
};

const reduceCase = (payload: CaseAdmin) => {
  const { slides, specimens, patient, documents, ...rest } = payload;

  return {
    ...rest,
    patient: patient?.id,
    slides: slides?.map((slide) => slide.id || 0),
    specimens: specimens?.map((specimen) => specimen.id || 0),
    documents: documents?.filter(
      (doc) => doc.category !== CaseDocumentAdmin.category.CASE_REPORT
    ),
    isLoading: false,
    accession: rest.accession || "",
  };
};

export const AdminCaseReducer = (
  state: CaseState = initialState,
  action: AnyAction
): CaseState => {
  switch (action.type) {
    case FETCH_LIS_CASE_REQUEST:
      return initialState;
    case FETCH_LIS_CASE_SUCCESS:
    case UPDATE_LIS_CASE_SUCCESS:
      return reduceCase(action.payload.response);
    case FETCH_LIS_CASE_FAILURE:
      return { ...initialState, isLoading: false };
    case UPLOAD_LIS_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: state.documents
          ? [...state.documents, action.payload.response]
          : [action.payload.response],
      };
    case CREATE_LIS_SPECIMEN_SUCCESS:
      return {
        ...state,
        specimens: state.specimens
          ? [...state.specimens, action.payload.response.id]
          : [action.payload.response.id],
      };
    case DELETE_LIS_SPECIMEN_SUCCESS:
      return {
        ...state,
        specimens: state.specimens
          ? state.specimens.filter(
              (specimenID) => specimenID !== action.args.id
            )
          : state.specimens,
      };
    case ADMIN_UPDATE_INTEGRATIONS_SUCCESS:
      return (
        state && {
          ...state,
          ...action.payload.case,
        }
      );
    default:
      return state;
  }
};
